import { MapInterval } from "@/engine/engine";
import INTERVAL_TYPES, { getParentType } from "./intervalTypes";
import { constructInterval } from "./intervals";
import { HGInterval } from "./types";

const intervalTypeNames: string[] = Object.keys(INTERVAL_TYPES);

export const names = {
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  monthsShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  weekdays: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  weekDaysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  "5th": ["1st", "2nd", "3rd", "4th", "5th"],
  "5": ["1", "2", "3", "4", "5"],
  "53th": [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
    "13th",
    "14th",
    "15th",
    "16th",
    "17th",
    "18th",
    "19th",
    "20th",
    "21st",
    "22nd",
    "23rd",
    "24th",
    "25th",
    "26th",
    "27th",
    "28th",
    "29th",
    "30th",
    "31st",
    "32nd",
    "33rd",
    "34th",
    "35th",
    "36th",
    "37th",
    "38th",
    "39th",
    "40th",
    "41st",
    "42nd",
    "43rd",
    "44th",
    "45th",
    "46th",
    "47th",
    "48th",
    "49th",
    "50th",
    "51st",
    "52nd",
    "53rd",
  ],
  "31": [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ],
  "31th": [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
    "13th",
    "14th",
    "15th",
    "16th",
    "17th",
    "18th",
    "19th",
    "20th",
    "21st",
    "22nd",
    "23rd",
    "24th",
    "25th",
    "26th",
    "27th",
    "28th",
    "29th",
    "30th",
    "31st",
  ],
  "24": [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ],
  "24th": [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
    "13th",
    "14th",
    "15th",
    "16th",
    "17th",
    "18th",
    "19th",
    "20th",
    "21st",
    "22nd",
    "23rd",
    "24th",
  ],
  "60": [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
  ],
  "59th": [
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
    "13th",
    "14th",
    "15th",
    "16th",
    "17th",
    "18th",
    "19th",
    "20th",
    "21st",
    "22nd",
    "23rd",
    "24th",
    "25th",
    "26th",
    "27th",
    "28th",
    "29th",
    "30th",
    "31st",
    "32nd",
    "33rd",
    "34th",
    "35th",
    "36th",
    "37th",
    "38th",
    "39th",
    "40th",
    "41st",
    "42nd",
    "43rd",
    "44th",
    "45th",
    "46th",
    "47th",
    "48th",
    "49th",
    "50th",
    "51st",
    "52nd",
    "53rd",
    "54th",
    "55th",
    "56th",
    "57th",
    "58th",
    "59th",
  ],
};

const defaultFormats = {
  byr: "<nth> billion <bcera>",
  byr_q: "[byr/byr_q-5th] quarter of <parent>",
  byr_t: "[byr/byr_t-5th] third of <parent>",
  byr_h: "[byr/byr_h-5th] half of <parent>",
  myr: "<nth> million <bcera>",
  myr_q: "[myr/myr_q-5th] quarter of <parent>",
  myr_t: "[myr/myr_t-5th] third of <parent>",
  myr_h: "[myr/myr_h-5th] half of <parent>",
  kyr: "<nth> millenium <bcera>",
  kyr_q: "[kyr/kyr_q-5th] quarter of <parent>",
  kyr_t: "[kyr/kyr_t-5th] third of <parent>",
  kyr_h: "[kyr/kyr_h-5th] half of <parent>",
  c: "<nth> century <bcera>",
  c_q: "[c/c_q-5th] quarter of <parent>",
  c_t: "[c/c_t-5th] third of <parent>",
  c_h: "[c/c_h-5th] half of <parent>",
  dec: "<yrange><bcera>",
  y: "<n> <bcera>",
  y_q: "[y/y_q-5th] quarter of <parent>",
  y_t: "[y/y_t-5th] third of <parent>",
  y_h: "[y/y_h-5th] half of <parent>",
  m: "[y/m-months] <y> <bcera>",
  m_t: "[m/m_t-5th] third of <parent>",
  m_h: "[m/m_h-5th] half of <parent>",
  w: "<drange> <y><bcera>",
  d: "[m/d-31] [y/m-months] <y><bcera>, [w/d-weekdays]",
  d_q: "[d/d_q-5th] quarter of <parent>",
  d_t: "[d/d_t-5th] third of <parent>",
  d_h: "[d/d_h-5th] half of <parent>",
  h: "[m/d-31] [y/m-months] <y><bcera>, [d/h-24th] hour",
  h_q: "[h/h_q-5th] quarter of <parent>",
  h_t: "[h/h_t-5th] third of <parent>",
  h_h: "[h/h_h-5th] half of <parent>",
  min: "[m/d-31] [y/m-months] <y><bcera>, [d/h-60]:[h/min-60]",
  s: "[m/d-31] [y/m-months] <y><bcera>, [d/h-60]:[h/min-60]:[min/s-60]",
};

function convertInterval(
  n: bigint,
  sourceIt: string,
  targetIt: string,
): bigint {
  const intervals = MapInterval(
    {
      n,
      it: sourceIt,
    },
    targetIt,
  );

  return intervals.begin.n;
}

function getIntervalIndex(n: bigint, it: string, parentIt: string): number {
  if (it === "w") {
    const intervals = MapInterval(constructInterval(n, "w"), parentIt, "d");
    const dayIndex = intervals.begin.offset;
    return Number(dayIndex / 7n);
  }
  const intervals = MapInterval(constructInterval(n, it), parentIt, it);
  return Number(intervals.begin.offset);
}

export function getName(
  interval: HGInterval,
  formats: Record<string, string> = defaultFormats,
): string {
  const { n, it } = interval;
  const format = { ...defaultFormats, ...formats }[it];
  if (!format) throw new Error(`Unknown interval type: ${it}`);
  const abs = (x: bigint) => (x < 0n ? -x : x);

  const getOrdinal = (num: number): string => {
    const s = ["th", "st", "nd", "rd"];
    const v = num % 100;
    return num + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const getEra = (n: bigint) => (n < 0n ? "BC" : "AD");
  const getBcEra = (n: bigint) => (n < 0n ? " BC" : "");

  const parsePlaceholder = (ph: string): string => {
    if (ph === "n") return abs(n).toString();
    if (ph === "nth") return getOrdinal(Number(abs(n)));
    if (ph === "era") return getEra(n);
    if (ph === "bcera") return getBcEra(n);
    if (ph === "parent") {
      const parentIt = getParentType(it);
      if (!parentIt) return "";
      const span = MapInterval({ n, it }, parentIt);
      return getName({ n: span.begin.n, it: parentIt }, formats);
    }
    if (ph === "yrange") {
      const span = MapInterval({ n, it }, "y");
      return `${abs(span.begin.n)}-${abs(span.end.n)}`;
    }
    if (ph === "drange") {
      const beginDayN = convertInterval(n, it, "d");
      const endDayN = beginDayN + 6n;
      const beginMonthN = convertInterval(beginDayN, "d", "m");
      const endMonthN = convertInterval(endDayN, "d", "m");
      const beginDayNum = (names as Record<string, string[]>)["31"][
        getIntervalIndex(beginDayN, "d", "m")
      ];
      const endDayNum = (names as Record<string, string[]>)["31"][
        getIntervalIndex(endDayN, "d", "m")
      ];
      const beginMonthName = (names as Record<string, string[]>).months[
        getIntervalIndex(beginMonthN, "m", "y")
      ];
      const endMonthName = (names as Record<string, string[]>).months[
        getIntervalIndex(endMonthN, "m", "y")
      ];

      if (beginMonthN === endMonthN) {
        return `${beginDayNum}-${endDayNum} ${beginMonthName}`;
      }
      return `${beginDayNum} ${beginMonthName} - ${endDayNum} ${endMonthName}`;
    }

    // [parent/child-arrayName]
    const matchNamedArray = ph.match(/^(.+?)\/(.+?)-(.+)$/);
    if (matchNamedArray) {
      const [, parent, child, name] = matchNamedArray;
      const childN = convertInterval(n, it, child);
      const idx = getIntervalIndex(childN, child, parent);
      const array = (names as Record<string, string[]>)[name];
      return array?.[idx] ?? `[Invalid index: ${idx}]`;
    }

    // [parent/child]
    const matchRatio = ph.match(/^(.+?)\/(.+)$/);
    if (matchRatio) {
      const [, parent, child] = matchRatio;
      const childN = convertInterval(n, it, child);
      const val = getIntervalIndex(childN, child, parent);
      return val.toString();
    }

    // single interval type
    if (intervalTypeNames.includes(ph)) {
      const val = convertInterval(n, it, ph);
      return (val < 0n ? -val : val).toString();
    }

    return `[Unknown: ${ph}]`;
  };

  const replacePlaceholders = (input: string): string => {
    const squareRe = /\[([^\]]+)]/g;
    const angleRe = /<([^>]+)>/g;

    // Replace square brackets
    let result = "";
    let lastIndex = 0;
    for (const match of input.matchAll(squareRe)) {
      result += input.slice(lastIndex, match.index!);
      result += parsePlaceholder(match[1]);
      lastIndex = match.index! + match[0].length;
    }
    result += input.slice(lastIndex);

    // Replace angle brackets
    let final = "";
    lastIndex = 0;
    for (const match of result.matchAll(angleRe)) {
      final += result.slice(lastIndex, match.index!);
      final += parsePlaceholder(match[1]);
      lastIndex = match.index! + match[0].length;
    }
    final += result.slice(lastIndex);

    return final;
  };

  return replacePlaceholders(format);
}

export function getShortName(interval: HGInterval) {
  const shortFormats = {
    s: "[min/s-60]",
    min: "[h/min-60]",
    h: "[d/h-60]",
    d: "[m/d-31]",
    m: "[y/m-monthsShort]",
    h_q: "[h/h_q-5th]",
    h_t: "[h/h_t-5th]",
    h_h: "[h/h_h-5th]",
    d_q: "[d/d_q-5th]",
    d_t: "[d/d_t-5th]",
    d_h: "[d/d_h-5th]",
    m_t: "[m/m_t-5th]",
    m_h: "[m/m_h-5th]",
    y_q: "[y/y_q-5th]",
    y_t: "[y/y_t-5th]",
    y_h: "[y/y_h-5th]",
    c_q: "[c/c_q-5th]",
    c_t: "[c/c_t-5th]",
    c_h: "[c/c_h-5th]",
    kyr_q: "[kyr/kyr_q-5th]",
    kyr_t: "[kyr/kyr_t-5th]",
    kyr_h: "[kyr/kyr_h-5th]",
    myr_q: "[myr/myr_q-5th]",
    myr_t: "[myr/myr_t-5th]",
    myr_h: "[myr/myr_h-5th]",
    byr_q: "[byr/byr_q-5th]",
    byr_t: "[byr/byr_t-5th]",
    byr_h: "[byr/byr_h-5th]",
  };
  return getName(interval, shortFormats);
}
